import React, { useState, useEffect } from "react";
import statsScreenNewApi from "../../API/statsScreenNewAPI";
import {
  Table,
  Pagination,
  Row,
  Col,
  Spinner,
  Alert,
  Form,
  InputGroup,
} from "react-bootstrap";
import InvoiceDetailsModal from "./InvoiceDetailsModal";
import { utcToLocaleDateTime } from "../../utils/timeConverter";

const AllCollections = ({ auctionHouse }) => {
  const [collections, setCollections] = useState([]);
  const [search, setSearch] = useState("");
  const [onKeyPress, setOnKeyPress] = useState(false);
  const [active, setActive] = useState("1");
  const [status, setStatus] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [maximumRows] = useState(50);
  const [showModal, setShowModal] = useState(false);
  const [currentInvoiceId, setCurrentInvoiceId] = useState("");
  const [paginationItems, setPaginationItems] = useState([]);

  useEffect(() => {
    const getCollections = async () => {
      try {
        setIsLoading(true);
        const result = await statsScreenNewApi.get(
          `${
            process.env.REACT_APP_AOMS_AUTH_API
          }/collections/get-all-collections-stats?search=${search}&active=${active}&status=${status}&startRowIndex=${
            (activePage - 1) * maximumRows
          }&maximumRows=${maximumRows}`
        );

        setCollections(result.data);
        handleSetPagination(result.data.count);
        setIsLoading(false);
      } catch (err) {
        console.log(err);
        setIsLoading(false);
        setErrorMessage(err.message);
      }
    };
    getCollections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auctionHouse, active, status, activePage, onKeyPress]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    switch (name) {
      case "active":
        setActive(value);
        break;
      case "status":
        setStatus(value);
        break;
      case "search":
        setSearch(value);
        setOnKeyPress(false);
        break;
      default:
        break;
    }
  };

  const handleKeyDown = (e) => {
    // e.preventDefault();
    if (e.key === "Enter") {
      setOnKeyPress(true);
    }
  };

  const handlePagination = (newActivePage) => {
    setActivePage(newActivePage);
  };

  const handleSetPagination = (count) => {
    const items = [];
    const range = [];
    let l = null;
    const rangeWithDots = [];
    const totalPages = Math.ceil(count / maximumRows);
    const left = activePage - 2;
    const right = activePage + 2;

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= left && i < right)) {
        range.push(i);
      }
    }

    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    if (rangeWithDots.length > 1) {
      for (let i = 0; i < rangeWithDots.length; i++) {
        items.push(
          <Pagination.Item
            key={i}
            active={rangeWithDots[i] === activePage}
            onClick={() =>
              rangeWithDots[i] !== "..." && handlePagination(rangeWithDots[i])
            }
            className="text-white font-weight-bold"
          >
            {rangeWithDots[i]}
          </Pagination.Item>
        );
      }
    }

    setPaginationItems(items);
  };

  const handleShowModal = (invoiceId) => {
    setCurrentInvoiceId(invoiceId);
    setShowModal(true);
  };

  return (
    <div>
      <InvoiceDetailsModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        invoiceId={currentInvoiceId}
      />
      {isLoading ? (
        <Spinner animation="border" variant="primary" role="status" />
      ) : errorMessage ? (
        <Alert variant="danger">{errorMessage}</Alert>
      ) : (
        <Row>
          <Row className="d-flex flex-row">
            <Col>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="InvoiceNo, UserId, Username or Email"
                  aria-label="Search"
                  aria-describedby="collection-search"
                  name="search"
                  value={search}
                  onChange={handleChange}
                  onKeyPress={handleKeyDown}
                />
              </InputGroup>
            </Col>
            <Col>
              <Form.Select
                name="active"
                aria-label="active"
                onChange={handleChange}
              >
                <option value="">Active</option>
                <option value="1">True</option>
                <option value="0">False</option>
              </Form.Select>
            </Col>
            <Col>
              <Form.Select
                name="status"
                aria-label="status"
                onChange={handleChange}
              >
                <option value="">Status</option>
                <option value="0">Created</option>
                <option value="1">Pending</option>
                <option value="2">Issues</option>
                <option value="3">Completed</option>
                <option value="5">Hanover Start</option>
                <option value="6">Hanover Complete</option>
              </Form.Select>
            </Col>
          </Row>
          <Table striped bordered hover responsive="sm" className="mt-2">
            <thead>
              <tr>
                <th>InvoiceNo</th>
                <th>Active</th>
                <th>Status</th>
                <th>Customer</th>
                <th>StartDate</th>
                <th>UpdateDate</th>
                <th>PrePickPicker</th>
                <th>PrePickStart</th>
                <th>PrePickEnd</th>
                <th>TimeDiff</th>
                <th>HandoverStart</th>
                <th>HandoverPicker</th>
                <th>HandoverEnd</th>
                <th>InvoiceDate</th>
                <th>CollectionDeadLine</th>
                <th>TotalLots</th>
                <th>MissingLots</th>
                <th>SuspendReason</th>
              </tr>
            </thead>
            <tbody>
              {collections?.result?.map((collection) => (
                <tr
                  key={collection.id}
                  className={`${
                    collection.status === "Created"
                      ? "collectionStatusCreated"
                      : collection.status === "Pending"
                      ? "collectionStatusPending"
                      : collection.status === "Issues"
                      ? "collectionStatusIssues"
                      : "collectionStatusCompleted"
                  }`}
                  onClick={() => handleShowModal(collection.invoiceId)}
                >
                  <td className="text-white">{collection.invoiceId}</td>
                  <td className="text-white">{collection.active}</td>
                  <td className="text-white">{collection.status}</td>
                  <td className="text-white">{collection.customerName}</td>

                  <td className="text-white">
                    {utcToLocaleDateTime(collection.creationDate)}
                  </td>
                  <td className="text-white">
                    {utcToLocaleDateTime(collection.updatedAt)}
                  </td>
                  <td className="text-white">{collection.pickerName}</td>
                  <td className="text-white">
                    {collection.pickingStart &&
                      utcToLocaleDateTime(collection.pickingStart)}
                  </td>
                  <td className="text-white">
                    {collection.pickingEnd &&
                      utcToLocaleDateTime(collection.pickingEnd)}
                  </td>
                  <td className="text-white">{collection.timeDifference}</td>
                  <td className="text-white">
                    {collection.handoverPickerName}
                  </td>
                  <td className="text-white">
                    {collection.handoverStart &&
                      utcToLocaleDateTime(collection.handoverStart)}
                  </td>
                  <td className="text-white">
                    {collection.handoverEnd &&
                      utcToLocaleDateTime(collection.handoverEnd)}
                  </td>
                  <td className="text-white">
                    {utcToLocaleDateTime(collection.invoiceDate)}
                  </td>
                  <td className="text-white">
                    {utcToLocaleDateTime(collection.collectionDeadline)}
                  </td>
                  <td className="text-white">{collection.totalLots}</td>
                  <td className="text-white">{collection.lotsLeftUnpicked}</td>
                  <td className="text-white">{collection.suspendReason}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagination className="d-flex flex-wrap justify-content-end">
            {activePage > 1 && (
              <Pagination.Prev
                onClick={() => {
                  const previousPage = activePage - 1;
                  handlePagination(previousPage);
                }}
              />
            )}
            {paginationItems}
            {activePage !== paginationItems.length && (
              <Pagination.Next
                onClick={() => {
                  const nextPage = activePage + 1;
                  handlePagination(nextPage);
                }}
              />
            )}
          </Pagination>
        </Row>
      )}
    </div>
  );
};

export default AllCollections;
